import _classCallCheck from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/createClass";
import { Parallax } from "./Parallax";
export var HoverEvent = /*#__PURE__*/function () {
  function HoverEvent() {
    _classCallCheck(this, HoverEvent);

    this.enable = false;
    this.mode = [];
    this.parallax = new Parallax();
  }

  _createClass(HoverEvent, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      this.parallax.load(data.parallax);
    }
  }]);

  return HoverEvent;
}();